// import vue
import Vue from 'vue'

// Copy to clipboard lib
import VueClipboard from 'vue-clipboard2'

Vue.use(VueClipboard)
